import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';

export const MyHubPage = styled.div`
  margin: 24px auto 0;
  padding: 0 15px;
  max-width: 920px;
`;

export const MainContent = styled.div`
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const PromptLoginTitle = styled.div`
  margin: auto;
  max-width: 300px;
  padding: 8px 0px;
  font-weight: bold;
  margin-top: 15px;

  @media ${viewports['md-and-up']} {
    max-width: 100%;
  }
`;

export const PromptLoginDescription = styled.div`
  margin: auto;
  max-width: 300px;
  padding: 8px 0px;

  @media ${viewports['md-and-up']} {
    max-width: 450px;
  }
`;
